module.exports = __webpack_public_path__ + "static/media/dorpdown-icon.63571509.svg";